import * as styles from "./ReadMore.styles";

const ReadMore = () => {
  return (
    <span css={styles.readMore}>
      Read more <i css={styles.icon} aria-hidden="true" className="fa fa-long-arrow-right" />
    </span>
  );
};

export { ReadMore };
